import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=12b2a7dd&scoped=true"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"
import style0 from "./UserLogin.vue?vue&type=style&index=0&id=12b2a7dd&prod&lang=scss&scoped=true"
import style1 from "./UserLogin.vue?vue&type=style&index=1&id=12b2a7dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2a7dd",
  null
  
)

export default component.exports